import { ImpactModule } from 'types'

export const CITIZEN_PORTAL_MODULE: ImpactModule = {
  NAME: 'CITIZEN_PORTAL',
  NAME_PTBR: 'Portal Cidadão',
  UPPER_NAME: 'CITIZEN_PORTAL',
  API_NAME: '',
}
